import { IconScan } from '@tabler/icons-react'
import { useTheme } from '@mui/material'
import React from 'react'
import {
  MetaCardContainer,
  MetaThumbnailContainer,
  MetaPlaceholderTile,
  MetaImage,
  MetaContentContainer,
  MetaRestaurantName,
  MetaInfoRow,
  MetaText,
} from '../styled/SavedMenuDetail.styled'

interface SavedMenuMetaCardProps {
  imageUrl?: string
  restaurantName?: string
  dishCount: number
  lastUpdated: string
}

const SavedMenuMetaCard: React.FC<SavedMenuMetaCardProps> = ({
  imageUrl,
  restaurantName,
  dishCount,
  lastUpdated,
}): JSX.Element => {
  const theme = useTheme()
  return (
    <MetaCardContainer>
      {/* Thumbnail */}
      <MetaThumbnailContainer>
        {imageUrl ? (
          <MetaImage src={imageUrl} alt={restaurantName ?? 'menu'} />
        ) : (
          <MetaPlaceholderTile>
            <IconScan size={40} color={theme.palette.primary.main} stroke={1.5} />
          </MetaPlaceholderTile>
        )}
      </MetaThumbnailContainer>

      {/* Content */}
      <MetaContentContainer>
        {/* Restaurant name */}
        <MetaRestaurantName>
          {restaurantName ?? 'No restaurant linked'}
        </MetaRestaurantName>

        {/* Info row */}
        <MetaInfoRow>
          <MetaText>{dishCount} dishes</MetaText>
          <MetaText>•</MetaText>
          <MetaText>{lastUpdated}</MetaText>
        </MetaInfoRow>
      </MetaContentContainer>
    </MetaCardContainer>
  )
}

export default SavedMenuMetaCard
